import Head from 'next/head';
import React from "react";
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';

import Published from 'PublishedNew/components/Published.js';
import rootReducer from 'New/redux/reducer/rootReducer';
import HeaderUser from '../header_user';

const store = createStore(rootReducer, applyMiddleware(thunk));

function PublishedComponent() {

    return <>
        <HeaderUser />
        <Head>
            <title>myiFloorPlans</title>
            <link rel="stylesheet" href="/static/frontend/styles/published.css" />
            <link rel="stylesheet" href='/static/frontend/App.css' />
            <link rel="stylesheet" href='/static/frontend/App_other.css' />
            <link rel="stylesheet" href='/static/frontend/styles/new.css' />
        </Head>
        <div><input type="hidden" value="" id="dataEdit" />
            <div id="app">
                <div className="PublishedWrapper">
                    <Provider store={store}>
                        <div className="title_block"><h2>My iFloorPlans</h2></div>
                        <Published />
                    </Provider>
                </div>
            </div>
        </div>
    </>;
}

export default PublishedComponent;